import { render, staticRenderFns } from "./TheTopBar.vue?vue&type=template&id=b245b9e8&scoped=true&"
import script from "./TheTopBar.vue?vue&type=script&lang=js&"
export * from "./TheTopBar.vue?vue&type=script&lang=js&"
import style0 from "./TheTopBar.vue?vue&type=style&index=0&id=b245b9e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b245b9e8",
  null
  
)

export default component.exports